export function formatNIS(agorot: number, showSymbol = true): string {
  const nis = agorot / 100;
  const formatted = new Intl.NumberFormat('he-IL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(nis);
  return showSymbol ? `₪${formatted}` : formatted;
}
